import { createSelector } from 'reselect';

import { getNormalizedAccountingAccounts } from 'store/accounting/selectors';

import { getCompany } from './company.selectors';

export const getAccountingSettings = createSelector(getCompany, state => state.accountingSettings);

export const getExtendedAccountingSettings = createSelector(
  [getAccountingSettings, getNormalizedAccountingAccounts],
  (accountingSettings, normalizedAccountingAccounts) => {
    if (!accountingSettings) {
      return {};
    }

    return Object.keys(accountingSettings).reduce((acc, item) => {
      if (item === 'companyId') {
        return acc;
      }

      acc[item] = {
        id: accountingSettings[item],
        name: normalizedAccountingAccounts[accountingSettings[item]],
      };

      return acc;
    }, {});
  },
);
